/**
 * セッションキー
 */
export const SESSION_KEY = {
  // ログインユーザ情報
  loginUserInformation: 'loginUserInformation',

  // ログインアウト時メッセージコード
  loginOutMessageCode: 'loginOutMessageCode',

  // ログイン状態(ログイン中:true or 未ログイン:false)
  loginState: 'loginState',

  // 文字サイズ情報(標準:false or 値なし,拡大:true)
  textSize: 'textSize',

  // 全辞書値情報
  dicList: 'dicList',

  // 数量画面テーブル状態
  quantityDataTable: 'quantityDataTable',

  // 事務局代行登録用
  altUserBySecretariat: 'altUserBySecretariat',
};
